import React from 'react'
import PropTypes from 'prop-types'

import BasicViewComponent from './BasicViewComponent'

class Image extends BasicViewComponent {

  render () {
    if (!super.conditionsAreMet()) {
      return null
    }

    let imageUrl = this.evalConfigValue(this.props.config.src)
    if (!imageUrl && this.props.config.srcFallback) {
      imageUrl = this.evalConfigValue(this.props.config.srcFallback)
    }

    const useSpan = !this.props.config.hasOwnProperty('useSpan') || this.props.config.useSpan

    if (!imageUrl) {
      return (
        <span
          onClick={this.onTouchTap}
          className={this.cssClass}
        />
      )
    }

    if (useSpan) {
      return (
        <span
          onClick={this.onTouchTap}
          className={this.cssClass}
        >
          <img
            alt=''
            className={`${this.cssClass}-img`}
            src={imageUrl}
          />
        </span>
      )
    }
    return (
      <img
        alt=''
        onClick={this.onTouchTap}
        className={this.cssClass}
        src={imageUrl}
      />
    )
  }

}

Image.TYPE = 'image'

Image.propTypes = {
  config: PropTypes.object.isRequired
}

export default Image



// WEBPACK FOOTER //
// ./src/components/ViewComponents/Image.js